/**
 * GlobalView — Pending Page
 *
 * Shown to users with status PENDING (§25.2).
 * "Ihr Konto wird geprüft."
 */

import { useAuthStore } from '../stores/authStore';
import styles from './PendingPage.module.css';

export default function PendingPage() {
  const signOut = useAuthStore((s) => s.signOut);
  const user = useAuthStore((s) => s.user);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconPulse}>
          <div className={styles.dot} />
        </div>

        <h1 className={styles.title}>Konto wird geprüft</h1>

        <p className={styles.message}>
          Hallo{user?.displayName ? ` ${user.displayName}` : ''},<br />
          Ihr Konto wurde erfolgreich registriert und wartet auf Freischaltung
          durch einen Administrator.
        </p>

        <p className={styles.submessage}>
          Sie werden benachrichtigt, sobald Ihr Zugang freigeschaltet wurde.
        </p>

        <button
          className={styles.signOutButton}
          onClick={signOut}
          id="pending-sign-out"
        >
          Abmelden
        </button>
      </div>
    </div>
  );
}
